var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
var swal = require('bootstrap-sweetalert');
swal.setDefaults({ animation: false });

var router = require('./router').router;
var signin = require('./auth-handler').signin;
var awsConstants = require('./constants').awsConstants;

var signinFormController = {
    init: function () {
        this.isProcessing = false;
        signinFormView.init();
    },
    signinValidate: function (username, password) {
        var errorMessages = [];
        if (!username.length) {
            errorMessages.push('Username is required.');
        }

        if (password.length < 8) {
            errorMessages.push('Password must be at least 8 characters in length');
        }

        if (!awsConstants.AWSPasswordRegex.test(password)) {
            errorMessages.push(
                'Password must include an uppercase letter, a lower case letter, a number and a special character.');
        }
        return errorMessages;
    },
    handleSignin: function (username, password) {
        var self = this;
        if (this.isProcessing) return; // Avoid submits when in progress
        this.isProcessing = true;
        signinFormView.toggleSpinnerState('show');
        var errorMessages = this.signinValidate(username, password);
        if (errorMessages.length) {
            this.isProcessing = false;
            signinFormView.toggleSpinnerState('hide');
            swal('Validation Error', errorMessages.join('\n'), 'error');
            return;
        }
        signin(username, password)
            .then(function (result) {
                localStorage.setItem('username', username);
                router.navigate('/dashboard');
            })
            .catch(function (error) {
                self.isProcessing = false;
                if (error) {
                    signinFormView.toggleSpinnerState('hide');
                    swal('Sign In Error', error, 'error');
                }
            });
    },
    handleForgotPassword: function (username) {
        var self = this;
        if (this.isProcessing) return;
        this.isProcessing = true;
        signinFormView.toggleSpinnerState('show');
        var userPool = new AmazonCognitoIdentity.CognitoUserPool(awsConstants.getPoolData());
        var userData = {
            Username: username,
            Pool: userPool
        };
        var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.forgotPassword({
            onSuccess: function (result) {
                swal('Password Change Success', 'Please login with new password', 'success');
                signinFormView.updateViewOnForgotPasswordChangeSuccess();
            },
            onFailure: function (error) {
                self.isProcessing = false;
                signinFormView.toggleSpinnerState('hide');
                swal('Forgot Password Error', error, 'error');
            },
            inputVerificationCode: function () {
                var verificationCode;
                var newPassword;
                var _this = this;
                swal({
                    title: 'Verification Code Required',
                    text: 'Please check email sent to your inbox',
                    type: 'input',
                    showCancelButton: true,
                    closeOnConfirm: false,
                    inputPlaceholder: 'Enter Verification Code'
                }, function (inputValue) {
                    if (inputValue === false) return false;
                    if (inputValue === '') {
                        swal.showInputError('Code is required');
                        return false;
                    }
                    verificationCode = inputValue;
                    swal({
                        title: 'New Password Required',
                        text: 'Please enter your new password',
                        type: 'input',
                        showCancelButton: true,
                        closeOnConfirm: true,
                        inputPlaceholder: 'Enter New Password'
                    }, function (inputValue) {
                        if (inputValue === false) return false;
                        if (inputValue === '') {
                            swal.showInputError('Password is required');
                            return false;
                        }
                        newPassword = inputValue;
                        cognitoUser.confirmPassword(verificationCode, newPassword, _this);
                    });
                });
            }
        });
    }
};

var signinFormView = {
    init: function () {
        this.signinFormEl = document.querySelector('#signin-form');
        this.signinButtonTextEl = this.signinFormEl.querySelector('#signin-button-text');
        this.signinButtonSpinnerEl = this.signinFormEl.querySelector('#signin-button-spinner');
        this.forgotPasswordButtonEl = document.querySelector('#forgot-password-button');
        this.passwordInputEl = document.querySelector('#password');
        this.usernameEl = document.querySelector('#username');
        this.initForgotPasswordHandler();
        this.initSubmitHandler();
    },
    initForgotPasswordHandler: function () {
        var self = this;
        this.forgotPasswordButtonEl.addEventListener('click', function () {
            self.passwordInputEl.style.display = 'none';
            self.forgotPasswordButtonEl.style.display = 'none';
            self.signinButtonTextEl.innerHTML = 'Enter username to reset password';
            signinFormController.isForgotPassword = true;
        });
    },
    updateViewOnForgotPasswordChangeSuccess: function () {
        this.passwordInputEl.style.display = 'block';
        this.forgotPasswordButtonEl.style.display = 'none';
        this.toggleSpinnerState('hide');
        signinFormController.isForgotPassword = false;
        signinFormController.isProcessing = false;
    },
    initSubmitHandler: function () {
        var self = this;
        this.signinFormEl.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var username = self.usernameEl.value;
            if (signinFormController.isForgotPassword) {
                signinFormController.handleForgotPassword(username);
                return;
            }
            var password = self.passwordInputEl.value;
            signinFormController.handleSignin(username, password);
        });
    },
    toggleSpinnerState: function (state) {
        if (state === 'show') {
            if (signinFormController.isForgotPassword) {
                this.signinButtonTextEl.innerHTML = 'Sending Verification Code to your Inbox';
            } else {
                this.signinButtonTextEl.innerHTML = 'Signing in';
            }
            this.signinButtonSpinnerEl.style = 'margin-right:5px;';
        } else {
            this.signinButtonTextEl.innerHTML = 'Sign in';
            this.signinButtonSpinnerEl.style = 'visibility:hidden;';
        }
    }
};

module.exports = { signinFormController: signinFormController };
